export enum HttpStatus {
  /** The HTTP Status is not made available to our code, probably because of a CORS error. */
  Hidden = 0,

  Ok = 200,
  Created = 201,
  Accepted = 202,
  NoContent = 204,

  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  Locked = 423,
  TooManyRequests = 429,

  InternalServerError = 500,
  GatewayTimeout = 504,
}
